const opta = require('./i18.opta.js');
const _ = require('lodash');

module.exports = {
    en: _.extend(
        {
            ht: 'HT',
            finished: 'Finished',
            live: 'Live',
            new: 'new',
            at: 'at',
            'final.result': 'Final result',
            'status.full.finished': 'Final result',
            'status.full.postponed': 'Postponed',
            'status.full.inprogress': 'Live',
            'status.full.cancelled': 'Cancelled',

            'status.short.finished': 'FT',
            'status.short.postponed': 'POST',
            'status.short.inprogress': 'LIVE',
            'status.short.notstarted': '',
            'status.short.cancelled': 'CAN',

            Goalkeeper: 'Goalkeeper',
            Forward: 'Forward',
            Midfielder: 'Midfielder',
            Defender: 'Defender',
            Coach: 'Coach',

            'round.n': 'Round {0}',
            'win.short': 'W',
            'draw.short': 'D',
            'loss.short': 'L',
            'notPlayed.short': ' ',
            'shots.on.goal': 'Shots on goal',
            name: 'Name',
            all: 'All',
            topSpeed: 'Speeds',
            distance: 'Distances',
            'meters.short': 'm',
            'km/h': 'km/h',
            'matches.short': 'M',
            'goals.short': 'G',
            'points.short': 'P',
            '%': '%',
            ballpossession: 'Ball possession',
            averageShots: 'Shots per match',
            goalsAverage: 'Goals per match ',
            goalsScored: 'Goals scored',
            goalsConceded: 'Goals conceded',
            rank: 'Rank',
            points: 'Points',
            form: 'Form',
            vs: 'vs',
            round: 'round',
            goal: 'Goal',
            assist: 'Assist',
            owngoal: 'Own goal',
            yellow_card: 'Yellow card',
            red_card: 'Red card',
            goals: 'Goals',
            matches: 'Matches',
            attempts: 'Attempts',
            scoring: 'Scoring',
            penalty: 'Penalty goals',
            ycards: 'Yellow cards',
            rcards: 'Red cards',
            subs: 'Substitution',
            in: 'in',
            out: 'out',
            min: 'min',
            matchstart: 'Match start',
            odds: 'odds',
            draw: 'draw',
        },
        // ProStats.en,
        // F1.en
        // opta.en,
    ),
    da: {},
    no: {},
};



/** WEBPACK FOOTER **
 ** ../src/widgets/i18/default/i18.Common.js
 **/